import React from 'react';
import Module from 'Components/Core/Module';
import './Marketdata.css';

// Kleines Steuermodul fuer den IB-Gateway-Container (Chat vom 2026-08-07) -
// Start/Stop + READ_ONLY_API an/aus. Ruft NUR die IbGateway*-Backend-Tasks
// auf (siehe IbGatewayStop.inc & co.), die ihrerseits per Redis den
// host-seitigen Watcher ansteuern (ib-gateway-control.sh) - kein Container
// hat direkten Docker-Zugriff (Nutzerentscheidung). Admin-only auf
// Backend-Seite (makeAdminContent) - dieses Modul selbst pruft die
// Berechtigung nicht extra, ein nicht-berechtigter Aufruf laeuft einfach ins
// Leere (returncode -1).
export default function IbGatewayControl(props) {
	const x = props.x;
	const [status, setStatus] = React.useState(null);
	const [busy, setBusy] = React.useState('');

	function loadStatus() {
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=IbGatewayStatus', {}, (res) => {
			if (res.data.returncode === 1) {
				setStatus(res.data.content);
			}
		});
	}

	React.useEffect(() => {
		loadStatus();
		// Nach einer Aktion braucht der Watcher ein paar Sekunden (Container-
		// Neustart bei readonly-on/off, siehe ib-gateway-control.sh) - deshalb
		// hier ein simples Polling statt eines Live-Events.
		const timer = setInterval(loadStatus, 5000);
		return () => clearInterval(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function runAction(task, key) {
		setBusy(key);
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=' + task, {}, () => {
			// Watcher braucht kurz (Container stoppen/starten bzw. neu
			// erstellen bei readonly-on/off) - Status etwas verzoegert neu
			// laden statt sofort (waere noch der alte Stand).
			setTimeout(() => { setBusy(''); loadStatus(); }, 4000);
		});
	}

	return (
		<Module id={props.id} x={x} classes="module-ib-gateway-control" title={props.title} display="d-block">
			{status === null && <p>Lade…</p>}
			{status !== null &&
				<React.Fragment>
					<div className="brokerage-hint">
						Gateway-Container: {status.containerRunning === null ? 'unbekannt (Watcher nicht erreichbar?)' : (status.containerRunning ? 'läuft' : 'gestoppt')}
						{' · '}
						IB-Verbindung: {status.connected ? 'verbunden' : 'nicht verbunden'}
						{' · '}
						READ_ONLY_API: {status.readOnly === null ? 'unbekannt' : status.readOnly}
					</div>
					<div className="ib-gateway-control-buttons">
						<button
							type="button"
							className="btn btn-secondary"
							disabled={busy !== '' || status.containerRunning === false}
							onClick={() => runAction('IbGatewayStop', 'stop')}
						>
							{busy === 'stop' ? 'Fährt herunter…' : 'Gateway herunterfahren'}
						</button>
						<button
							type="button"
							className="btn btn-secondary"
							disabled={busy !== '' || status.containerRunning === true}
							onClick={() => runAction('IbGatewayStart', 'start')}
						>
							{busy === 'start' ? 'Fährt hoch…' : 'Gateway hochfahren'}
						</button>
						<button
							type="button"
							className="btn btn-secondary"
							disabled={busy !== '' || status.readOnly === 'yes'}
							onClick={() => runAction('IbGatewayReadOnlyOn', 'readonly-on')}
						>
							{busy === 'readonly-on' ? 'Schaltet um…' : 'Gateway ReadOnly On'}
						</button>
						<button
							type="button"
							className="btn btn-secondary"
							disabled={busy !== '' || status.readOnly === 'no'}
							onClick={() => runAction('IbGatewayReadOnlyOff', 'readonly-off')}
						>
							{busy === 'readonly-off' ? 'Schaltet um…' : 'Gateway ReadOnly Off'}
						</button>
					</div>
					{(busy === 'readonly-on' || busy === 'readonly-off') &&
						<p className="brokerage-hint">
							<i className="bi bi-exclamation-triangle"></i> READ_ONLY_API-Umschalten erstellt den Container neu - kurze Unterbrechung der Marktdaten-/Brokerage-Verbindung, ggf. neue 2FA-Anfrage.
						</p>
					}
				</React.Fragment>
			}
		</Module>
	);
}
